module.exports = __webpack_public_path__ + "img/mesacomvinho.d58f4d7b.webp";